export const SHOW_PREVIEW_ZONE = 'SHOW_PREVIEW_ZONE';
export const HIDE_PREVIEW_ZONE = 'HIDE_PREVIEW_ZONE';
